import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import './http'
import './filters'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC5uRQvpYkzVNBcW19JsyXy2EYbmShS5pA'
  }
})

Vue.use(Vuetify, {
  theme: {
    primary: '#2C3E50',
    secondary: colors.red.lighten4,
    accent: colors.indigo.base
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js